module.exports = __webpack_public_path__ + "img/canvas-day-normal.82d7a46c.jpg";